/**
 * `components.MuiAppBar` — top app bar background and positioning.
 * Discoverability: `MuiAppBar`, `AppBar`, `position`.
 *
 * @see https://mui.com/material-ui/api/app-bar/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiAppBar(theme: Theme): Pick<Components<Theme>, 'MuiAppBar'> {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: theme.palette.background.paper,
          color: theme.palette.text.primary,
          position: 'absolute',
        },
      },
    },
  };
}
